import * as React from 'react';
import type { SVGProps } from 'react';

const SvgTwitterBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={20} fill="none" {...props}>
    <path
      fill="#5B8ADA"
      d="M25 2.368c-.936.408-1.93.676-2.946.795A5.078 5.078 0 0 0 24.31.369a10.371 10.371 0 0 1-3.257 1.225A5.16 5.16 0 0 0 17.308 0c-2.832 0-5.129 2.26-5.129 5.049 0 .396.046.781.133 1.15A14.64 14.64 0 0 1 1.74.925a4.966 4.966 0 0 0-.694 2.538c0 1.752.906 3.298 2.282 4.203a5.17 5.17 0 0 1-2.324-.632v.064c0 2.446 1.768 4.487 4.114 4.95a5.215 5.215 0 0 1-2.316.087c.653 2.006 2.547 3.466 4.791 3.507a10.396 10.396 0 0 1-6.37 2.161c-.414 0-.822-.024-1.223-.07A14.685 14.685 0 0 0 7.862 20c9.435 0 14.593-7.694 14.593-14.366 0-.219-.004-.436-.014-.653 1.004-.714 1.87-1.6 2.559-2.613Z"
    />
  </svg>
);
export default SvgTwitterBlue;
